import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";

interface Props {
    questionConfigs: QuestionConfig[];
    readonly: boolean;
}

export const DataPrivacySection: React.FunctionComponent<Props> = ({ questionConfigs, readonly }) => {
    const getDividerStatus = (questionsBelow: string[]) => {
        return !questionConfigs.filter(q => questionsBelow.indexOf(q.id) !== -1).some(q => !q.disabled);
    };

    return (
        <ContextAwareProgressBarQuestionnaireSection title="Data Privacy (Please tick all that apply)" id="Consent">
            <CheckboxQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.PrivacyConsent)}
                readonly={readonly}
                value="Granted"
                hideDivider={getDividerStatus([questionIds.DataSecureConsent, questionIds.EmployeeAwareConsent])}
            />
            <CheckboxQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.EmployeeAwareConsent)}
                readonly={readonly}
                value="Granted"
                hideDivider={getDividerStatus([questionIds.DataSecureConsent])}
            />
            <CheckboxQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.DataSecureConsent)}
                readonly={readonly}
                value="Granted"
                hideDivider={true}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
